import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { showSnoozeBlocker } from '../../../../../../base/effects/showSnoozeBlocker';

export const onStartWorking = (): ThunkAction => {
    return (dispatch: Dispatch) => {
        dispatch(showSnoozeBlocker({ allow: 'allowStatusMapping' }));
    };
};
